import BienForm from './partials/BienForm/BienForm.partial';

const BienAdd = (props) => <BienForm {...props}/>;

export default BienAdd
